import { NavigationData } from "@lib/base/components/navigation/sidebar/sidebar.component.types";

export const WORKSPACE_NAVIGATION: NavigationData = {
    settings: {
        prefix: "workspace",
    },
    routes: [
        {
            key: "Dashboard",
            route: "dashboard",
            icon: "dashboard",
            permissions: [
                "DropPoint",
                "StorageUnit",
                "Order",
                "ReplenishmentRequest",
                "Alerte",
                "StorageUnit",
                "Station",
                "Tag",
            ],
        },
        {
            key: "Facilities",
            icon: "business",
            children: [
                {
                    key: "Hospital",
                    route: "facilities/hospitals",
                    icon: "local_hospital",
                    permissions: ["Hospital"],
                },
                {
                    key: "Drop Point",
                    route: "facilities/drop-points",
                    icon: "place",
                    permissions: ["DropPoint"],
                },
                {
                    key: "Stock matrix",
                    route: "facilities/storage-units",
                    icon: "shelves",
                    permissions: ["StorageUnit"],
                },
            ],
        },
        {
            key: "Supply",
            icon: "inventory",
            children: [
                {
                    key: "Orders",
                    route: "supply/orders",
                    icon: "order_approve",
                    permissions: ["Order"],
                },
                {
                    key: "Products",
                    route: "supply/products",
                    icon: "inventory",
                    permissions: ["Product"],
                },
            ],
        },
        {
            key: "Administration",
            icon: "assignment",
            permissions: ["WorkspaceAdministration"],
            children: [
                {
                    key: "Card export",
                    route: "administration/card-export",
                    icon: "file_export",
                    permissions: ["DropPoint"],
                },
                {
                    key: "Reports",
                    route: "administration/reports",
                    icon: "insert_chart",
                    permissions: ["KPI"],
                },
                {
                    key: "Logs",
                    route: "administration/logs",
                    icon: "work_history",
                    permissions: ["StorageUnitLog"],
                },
                {
                    key: "Import",
                    route: "administration/import",
                    icon: "download",
                    permissions: ["ImportHistory"],
                },
                {
                    key: "Scheduled Tasks",
                    route: "administration/scheduled-tasks",
                    icon: "schedule",
                    permissions: ["JobExecution"],
                },
                // {
                //     key: "routing.workspace.administration.categories._title",
                //     route: "administration/categories",
                //     icon: "category",
                //     permissions: ["Category"],
                // },
                // {
                //     key: "routing.workspace.administration.sub-categories._title",
                //     route: "administration/sub-categories",
                //     icon: "category_search",
                //     permissions: ["SubCategory"],
                // },
            ],
        },

    ],
};
